import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
    return {
        menu: {
            height: '100%',
            display: 'flex',
            flexGrow: 1,
            marginLeft: theme.spacing(3),
        },
        menuItem: {
            display: 'flex',
            color: theme.palette.text.secondary,
            transition: '.3s',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(0, 2),
            '&:hover': {
                color: theme.palette.primary.main,
            },
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(0, 1.5),
                '& h5': {
                    fontSize: '0.9rem',
                },
            },
        },
        selected: {
            color: theme.palette.primary.main,
        },
    };
});
